import { render } from "./TaskCenter.vue?vue&type=template&id=8c5bb21a&scoped=true&ts=true"
import script from "./TaskCenter.vue?vue&type=script&lang=ts"
export * from "./TaskCenter.vue?vue&type=script&lang=ts"

import "./TaskCenter.vue?vue&type=style&index=0&id=8c5bb21a&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5bb21a"]])

export default __exports__